import React from 'react'
import useNextDistributionDate from '@App/common/hooks/use-next-distribution-date'

const RoyaltiesStatementsContentHeader = () => {
    const nextDistributionDate = useNextDistributionDate()

    return (
        <>
            <p>
                Select your desired payee from the Payee drop-down menu. Then you can filter by distribution period and
                DSP in the corresponding drop-down menus.
            </p>
            <p>
                In the Select column, check the box(es) for any statements you would like to download or click{' '}
                <strong> Select All </strong> at the top of the column to select all statements.
            </p>
            <p>
                Scroll to the bottom and click
                <strong> Continue to download</strong>, then select your download options from the slide-out menu.
            </p>
            {nextDistributionDate && (
                <p>
                    Your Next Distribution Date: <strong>{nextDistributionDate}</strong>
                </p>
            )}
        </>
    )
}

export default RoyaltiesStatementsContentHeader
